<template>
  <ol role="list" class="flex items-center space-x-2">
    <li v-for="(breadcrumb, index) in breadcrumbs" :key="breadcrumb.title" :class="[{ 'cursor-pointer': breadcrumb.onClick }]" @click="breadcrumb.onClick && breadcrumb.onClick()">
      <div class="flex items-center">
        <chevron-right-icon class="h-4 w-4 flex-shrink-0 text-gray-300 mr-3" v-if="index" />
        <div :class="['text-xs font-thin text-gray-500', { 'text-primary-500 hover:text-primary-600': breadcrumb.onClick }]">
          {{ breadcrumb.title }}
        </div>
      </div>
    </li>
  </ol>
</template>

<script>
import { ChevronRightIcon } from "@/assets/svgs";

export default {
  components: {
    ChevronRightIcon,
  },
  props: {
    breadcrumbs: Array,
  },
};
</script>
